import styled from 'styled-components'

const EntityInnerItemsUi = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 20px;
`

export default EntityInnerItemsUi
